declare var SimpleBar: any;

export const customJS = {
    toggleBox:(e) => {
        var p = $(e.currentTarget).parent();
        if (p != undefined) {
            customJS.validateSection(p);
            p.toggleClass("hidden");
            p.find(".collapse__box__body").slideToggle();
        }
    },
    validateSection:(e) => {
        if ($(e).find('.ng-invalid.ng-touched:not(form)').length > 0) {
            $(e).addClass('invalid__fields');
        } else {
            $(e).removeClass('invalid__fields');
        }
    },
    verifyBoxes:(e, trackerId = null) => {
        //angular validations reflect with some dealy 
        setTimeout(() => {
            var boxes = <any>$(e).find('.collapse__box');
            let isToggled = false;
            for(const box of boxes) {
                const isEqual = box.isEqualNode(trackerId); // True for progress tracker only
                if (!isToggled && (isEqual || (!trackerId && $(box).find('.ng-invalid.ng-touched:not(form)').length > 0))) {
                    if ($(box).hasClass('hidden')) {
                        $(box).toggleClass('hidden');
                        $(box).find('.collapse__box__body').slideToggle();
                    }
                    $(box).find('.form-control.ng-invalid').first().focus(); 
                    isToggled = true;
                }
                else {
                    if (!$(box).hasClass('hidden')) {
                        $(box).toggleClass('hidden');
                        $(box).find('.collapse__box__body').slideToggle();
                    }
                }
                customJS.validateSection(box);
            }
        }, 200);
    },
    markTabAsPristine:(e) => {
        if ($(e).hasClass("dirty")) {
            $(e).removeClass("dirty");
        } else if ($(e).find(".tabs__content__box").hasClass("dirty")) {
            $(e).find(".tabs__content__box").removeClass("dirty");
        }
    },
    scrollToPageHeader:() => {
        setTimeout(() => {
            $(".main__content_section").animate({ scrollTop: 0 }, 1000);
        }, 5);
    },
    setScroll:(e) => {
      new SimpleBar(
        $(e).find(".k-grid-aria-root")[0], { autoHide: false }
      );
    },
    resetPage:(e) => {
        var boxes = <any>$(e).find('.collapse__box');
        for(const box of boxes) {
            if ($(box).hasClass('hidden')) {
                $(box).removeClass("hidden").find(".collapse__box__body").slideDown();
            }
        }
        customJS.resetBodyScroll();
    },
    resetBodyScroll() {
        setTimeout(() => {
            $(".main__content_section").scrollTop(1);
            $(".main__content_section").scrollTop(0);
        }, 30);
    },
    findToggleState:(e) => {
        var p = $(e.currentTarget).parent();
        if (p != undefined) {
           return p.find(".collapse__box__body").is(':visible');
        }
        
        return false;
    },
}
